import PlaceholderPricing from '../PlaceholderPricing'

const LAPlaceholderBlock = ({ blockSize }) =>
  [...Array(blockSize)].map((_, i) => <PlaceholderPricing key={i} />)

export default LAPlaceholderBlock
